import PropTypes from 'prop-types';
import React from 'react';
import FullscreenOverlay from './FullscreenOverlay';
import { getComponentClasses, bemComponent } from '@99designs/utils/app';

export const ModalHeader = bemComponent('modal__header');
export const ModalBody = bemComponent('modal__body');
export const ModalActions = bemComponent('modal__actions');

export class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isActive: props.isActive,
        };
        this.handleClose = this.handleClose.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        if (this.props.isActive) {
            this.modal.focus();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isActive && !this.props.isActive) {
            this.modal.focus();
        }
    }

    render() {
        const classes = getComponentClasses('modal', this.props.variations);

        return (
            <FullscreenOverlay
                variations={['transparent']}
                hasAdminBarOffset={false}
                isActive={this.state.isActive}
                isScrollableSmallScreens={true}
                enableScroll={false}
            >
                <div
                    className={classes}
                    onKeyDown={this.handleKeyDown}
                    tabIndex="0"
                    ref={modal => (this.modal = modal)}
                    data-modal-status={this.state.isActive ? 'active' : 'closed'}
                >
                    <div className="modal__container">{this.props.children}</div>
                    {this.renderCloseButton()}
                </div>
            </FullscreenOverlay>
        );
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ isActive: nextProps.isActive });
    }

    handleClose() {
        this.setState({ isActive: false }, this.props.onClose);
    }

    handleKeyDown(e) {
        if (this.props.isConfirmation) {
            return;
        }

        // esc
        if (e.keyCode === 27) {
            e.stopPropagation(); // prevent close of any underlying fullscreen overlay, e.g. DDO
            this.handleClose();
        }
    }

    renderCloseButton() {
        if (this.props.isConfirmation) {
            return null;
        }

        return <div className="modal__close" onClick={this.handleClose} />;
    }
}

Modal.propTypes = {
    isActive: PropTypes.bool,
    isConfirmation: PropTypes.bool,
    variations: PropTypes.array,
    onClose: PropTypes.func,
};

Modal.defaultProps = {
    isActive: false,
    isConfirmation: false,
    variations: [],
    onClose() {},
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/Modal.jsx